import { $$ } from 'utils/dom';
import Lightbox from 'modules/Lightbox/Lightbox';

const galleries = $$('.o-gallery');
if (galleries.length) {
  galleries.forEach(gallery => {
    new Lightbox(gallery, {
      selector: '.lightbox-toggle',
    }).init();
  });
}
